import React from "react";
import HelpCenterCard from "./HelpCenterCard";

const HelpCenter = ({
  title = "Help Center",
  description = "",
  heroImage = "",
  heroImageAlt = "",
  disclaimer = "",
  variant = "default",
  sections = [],
  onSelectSection,
  progress = {},
  area = "help",
  onToggleComplete,
}) => {
  const renderSection = (section, cardVariant) => {
    const item = progress[`${area}:${section.id}`] || {};
    const exampleIndexes = (section.content || [])
      .map((block, index) => block.type === "example" ? index : null)
      .filter((index) => index !== null);
    const rowBased = area === "learning" && exampleIndexes.length > 0;
    const rowsComplete = rowBased && exampleIndexes.every((index) =>
      progress[`${area}:${section.id}-row-${index}`]?.completed
    );
    return (
      <div className="group/card relative h-full transition-transform duration-200 hover:-translate-y-1" key={section.id}>
        {rowBased ? (
          rowsComplete && (
            <span className="absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-end overflow-hidden rounded-full bg-emerald-600 px-2.5 text-xs font-semibold text-white shadow transition-all duration-200 group-hover/card:w-24">
              <span aria-hidden="true">✓</span>
              <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-200 group-hover/card:ml-2 group-hover/card:max-w-16 group-hover/card:opacity-100">Complete</span>
            </span>
          )
        ) : (
          <label className="group/control absolute right-3 top-3 z-10 flex h-9 w-10 cursor-pointer items-center justify-end overflow-hidden rounded-full bg-white px-2.5 text-xs font-semibold shadow transition-all duration-200 group-hover/card:w-28 focus-within:w-28">
            <input type="checkbox" checked={Boolean(item.completed)}
              aria-label={item.completed ? "Mark incomplete" : "Mark complete"}
              onChange={(event) => onToggleComplete?.(section, event.target.checked)} />
            <span aria-hidden="true" className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-200 group-hover/card:ml-2 group-hover/card:max-w-20 group-hover/card:opacity-100 group-focus-within/control:ml-2 group-focus-within/control:max-w-20 group-focus-within/control:opacity-100">
              {item.completed ? "Completed" : "Complete"}
            </span>
          </label>
        )}
        <HelpCenterCard section={section} variant={cardVariant}
          onClick={() => onSelectSection(section)} />
      </div>
    );
  };
  return (
    <div className="flex min-h-[calc(100vh-83px)] flex-col px-4 pb-28 pt-8 sm:px-8 lg:px-12 lg:pb-20">
      <div
        className={`mb-10 ${
          heroImage ? "grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_minmax(16rem,24rem)]" : ""
        }`}
      >
        <div>
          <h2 className="text-3xl font-bold">{title}</h2>
          {description && (
            <p className="mt-4 max-w-3xl text-base leading-7 text-gray-700">
              {description}
            </p>
          )}
        </div>

        {heroImage && (
          <img
            src={heroImage}
            alt={heroImageAlt}
            className="mx-auto max-h-64 w-full rounded-2xl object-contain"
          />
        )}
      </div>

      {variant === "training" ? (
        <div className="pb-12">
          <div className="mx-auto max-w-5xl">
            <h3 className="mb-6 text-xl font-medium text-gray-900">
              General Guidance
            </h3>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
              {sections.slice(0, 3).map((section) => renderSection(section, "training"))}
            </div>
          </div>

          <div className="mx-auto my-10 flex max-w-6xl items-center gap-3 sm:my-14 sm:gap-6">
            <span className="h-px flex-1 bg-gray-400" aria-hidden="true" />
            <h3 className="whitespace-nowrap text-lg font-medium text-gray-900 sm:text-xl">
              Training By Age
            </h3>
            <span className="h-px flex-1 bg-gray-400" aria-hidden="true" />
          </div>

          <div className="mx-auto flex max-w-3xl flex-wrap justify-center gap-6 sm:gap-10">
            {sections.slice(3).map((section) => (
              <div key={section.id} className="w-full md:w-[calc(50%-1.25rem)]">
                {renderSection(section, "training-age")}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {sections.map((section) => renderSection(section))}
        </div>
      )}

      {disclaimer && (
        <p className="mx-auto mt-auto max-w-6xl pb-4 pt-16 text-xs leading-5 text-gray-700">
          <span className="font-semibold">Disclaimer: </span>
          {disclaimer}
        </p>
      )}
    </div>
  );
};

export default HelpCenter;
